import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authConfig } from '../../configs/authConfig';
import AuthPageShell from './AuthPageShell';
import SignupForm from './parts/SignupForm';

const SignupPage: React.FC = () => {
  const { currentUser, tenantData, signup, error: authError, loading: authLoading } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isProvisioned = Boolean(tenantData);

  if (currentUser && !authLoading) {
    if (isProvisioned) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/pricing" replace />;
  }

  const handleSignUp = async (data: { email: string; password: string }) => {
    setIsSubmitting(true);
    setError(null);
    try {
      await signup(data.email, data.password);
    } catch (err: any) {
      setError(authError || err.message || 'Failed to sign up');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (authLoading) {
    return (
      <AuthPageShell>
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600" />
        </div>
      </AuthPageShell>
    );
  }

  return (
    <AuthPageShell>
      <SignupForm
        title="Create your account"
        onSubmit={handleSignUp}
        onGoogle={() => {}}
        loading={isSubmitting}
        error={error}
        showGoogle={authConfig.googleAuthEnabled}
      />
    </AuthPageShell>
  );
};

export default SignupPage;
